// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  promiseId: __t.u64().primaryKey().name("promise_id"),
  civ: __t.string(),
  settlementId: __t.u64().name("settlement_id"),
  kind: __t.string(),
  billId: __t.u64().name("bill_id"),
  dueEpoch: __t.i64().name("due_epoch"),
  status: __t.string(),
  madeAt: __t.timestamp().name("made_at"),
});
